import { createTheme } from "@mui/material";

const themeForm = createTheme({
  typography: {
    fontFamily: "Sarabun, sans-serif",
    fontSize: 10,
    h6: {
      fontSize: 16,
      fontWeight: "bold",
    },
  },
});

export default themeForm;
